import { invoiceActions } from "../../actionTypes";

export const resetInvoices = () => {
	return async dispatch => {
		dispatch({
			type: invoiceActions.RESET_INVOICES,
		});
	};
};
